module.exports = __webpack_public_path__ + "app/images/footer/Baltimore Sun Awards 2020_300.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/footer/Baltimore Sun Awards 2020_300.png
// module id = 470
// module chunks = 0